export default function (LoadSaveService, $q, TranslateService) {
    var translateFn = TranslateService.instant;

    function whatStepCanBeSkipped(claim) {
        return claim.policy.value && claim.lossCause.value && claim.lossDate.value;
    }

    function riskUnitsStepCanBeSkipped(claim) {
        return claim.lobs.commercialProperty.value.fixedPropertyIncidents && claim.lobs.commercialProperty.value.fixedPropertyIncidents.length > 0;
    }

    var ACTION_MSG = {
        createClaim: {
            error: {
                title: 'fnol.cp.config.FlowConfig.Error creating claim',
                message: 'fnol.cp.config.FlowConfig.An error occurred attempting to create a claim.'
            },
            progress: {
                message: 'fnol.cp.config.FlowConfig.Creating draft claim...'
            }
        }
    };

    var ACTIONS = {
        createClaim: function createClaim(_ref) {
            var claim = _ref.value;

            if (claim.claimNumber) {
                return LoadSaveService.saveClaim(claim);
            }

            return LoadSaveService.createClaim(claim);
        }
    };

    return function (step, junction) {
        junction('cpSuccess');

        junction('cpError');

        step('cpWhat', true).onNext.goTo('cpRiskUnits').skipOnResumeIf(whatStepCanBeSkipped).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.step.cp.What');
        });

        step('cpRiskUnits').onNext.doAction(function (model) {
            return ACTIONS.createClaim(model);
        }, ACTION_MSG.createClaim).thenBranch(function () {
            return 'cpPropertyDetails';
        }, function () {
            return 'cpError';
        }).skipOnResumeIf(riskUnitsStepCanBeSkipped).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.step.cp.Buildings');
        });

        step('cpPropertyDetails').onNext.goTo('cpWhere').skipOnResumeIf(function (_ref2) {
            var claim = _ref2.value;
            return claim.lossLocation;
        }).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.step.cp.Details');
        });

        step('cpWhere').onNext.goTo('cpSuccess').skipOnResumeIf(function (_ref3) {
            var claim = _ref3.value;
            return claim.lossLocation && claim.lossLocation.city;
        }).isValid(function (model) {
            return model.aspects.valid && model.aspects.subtreeValid;
        }).label(function () {
            return translateFn('fnol.wizard.step.cp.Where');
        });
    };
}